var Wdot;
(function (Wdot) {
    var Ajax = (function () {
        function Ajax() {
            this.includeAjaxLoaderImg = true;
            this.ajaxQueue = [];
        }
        Ajax.prototype.Error = function (xhr, ajaxOptions, thrownError) {
            if (xhr.status === 403 || xhr.status === 401) {
                if (thrownError === 'LoggedOut') {
                    window.location.href = '/admin/account/logon';
                }
                else if (thrownError === 'Unauthorized') {
                    window.location.href = '/admin/account/unauthorized?unauthorizedmessage=Unauthorized Ajax Call';
                }
            }
            else if (xhr.status === 0) {
            }
            else if (xhr.status !== 200) {
                console.log("Error occured! " + xhr.status + " " + xhr.statusText);
            }
        };
        Ajax.prototype.BeforeSend = function () {
            if (this.includeAjaxLoaderImg) {
                $(".ajaxLoader").show();
                $(".ajaxLoader").removeClass("hidden");
            }
        };
        Ajax.prototype.Complete = function () {
            $(".ajaxLoader").hide();
            $(".ajaxLoader").addClass("hidden");
            this.includeAjaxLoaderImg = true;
        };
        Ajax.prototype.Post = function (url, data, successFn, dataType, contentType) {
            return $.ajax({
                type: 'Post',
                url: url,
                dataType: dataType,
                contentType: contentType ? contentType : "application/x-www-form-urlencoded",
                data: data,
                success: successFn
            });
        };
        Ajax.prototype.Get = function (url, data, successFn, dataType, includeAjaxLoader) {
            if (includeAjaxLoader !== undefined)
                this.includeAjaxLoaderImg = includeAjaxLoader;
            var lowerCaseUrl = url.toLowerCase();
            return $.ajax({
                type: 'Get',
                url: lowerCaseUrl,
                dataType: dataType,
                data: data,
                success: successFn,
                // error: function (err) {
                //     console.log('ajax.get.error:', err);
                // }
            });
        };
        Ajax.prototype.GetWithOutCache = function (url, data, successFn, dataType, includeAjaxLoader) {
            if (includeAjaxLoader !== undefined)
                this.includeAjaxLoaderImg = includeAjaxLoader;
            var lowerCaseUrl = url.toLowerCase();
            return $.ajax({
                type: 'Get',
                url: lowerCaseUrl,
                dataType: dataType,
                data: data,
                success: successFn,
                cache: false
            });
        };
        Ajax.prototype.AddAjaxLoader = function (selector, useBig) {
            if (useBig) {
                //return selector.append("<div class='ui-widget-overlay' style='width:" + $('body').width() + "px; height: " + $('body').height() + "px; z-index: 1001;'></div><div class='ajaxLoader' style='position:absolute; left:50%; top:50%; margin-left:-28px; margin-top:-28px; display:block;'><div class='ajaxImage' style='z-index:1002;background-image:url(/images/ajax-loader-big.gif); margin: auto; width:55px; height:55px; padding:0px'></div></div>");
                //MOVED ALL STYLES TO SASS
                return selector.append("<div class='ui-widget-overlay'></div><div class='ajaxLoader'><div class='ajaxImage'></div></div>");
            }
            //return selector.append("<div class='ajaxLoader' style='width: 100%; height: 16px; padding-top: 5px; padding-bottom:5px;'><div class='ajaxImage' style='background-image:url(/images/ajax-loader.gif); margin:auto; width:16px; height:16px; padding:0px'></div></div>");
            return selector.append("<div class='ajaxLoader'><div class='ajaxImage'></div></div>");
        };
        Ajax.prototype.RemoveAjaxLoader = function (selector, useBig) {
            if (useBig) {
                selector.find('.ui-widget-overlay').remove();
            }
            selector.find('.ajaxLoader').remove();
        };
        Ajax.prototype.ClearQueue = function () {
            $(this.ajaxQueue).each(function () {
                this.abort();
            });
            this.ajaxQueue = [];
        };
        Ajax.prototype.ClearQueueAndPushNewCall = function (call) {
            this.ClearQueue();
            this.ClearQueue();
            this.AddNewCall(call);
        };
        Ajax.prototype.AddNewCall = function (call) {
            this.ajaxQueue.push(call);
        };
        return Ajax;
    }());
    Wdot.Ajax = Ajax;
})(Wdot || (Wdot = {}));
//# sourceMappingURL=Ajax.js.map